import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/compat/firestore';
import { AngularFireAuth, } from '@angular/fire/compat/auth';
import { UserService } from './user.service';
import firebase from 'firebase/compat/app';
import { getAuth, signInWithCredential, linkWithCredential, OAuthProvider } from "firebase/auth";
import { FirebaseAuthentication } from '@awesome-cordova-plugins/firebase-authentication/ngx';
import * as Rx from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  loginMethod: any;
  phoneNumber: any;
  mobile: any;
  //url: any='https://spotyourdeal.com'
  url: any = 'https://us-central1-spotyourdeal-38ab2.cloudfunctions.net/api'
  constructor(private firebaseAuthentication: FirebaseAuthentication, private afAuth: AngularFireAuth, private http: HttpClient) {

  }

  verifyPhoneNumber(phone) {
    return new Promise((resolve, reject) => {
      this.firebaseAuthentication.verifyPhoneNumber("+" + phone, 3000).then(function(verificationId) {
        console.error("phoner number verification", verificationId);
        resolve(verificationId);
      }).catch(function(err) {
        console.error("phoner number verification failed", err);
        reject(err);
      });
    })
  }
  signInWithVerificationId(verificationId, smsCode) {
    return new Promise((resolve, reject) => {
      this.firebaseAuthentication.signInWithVerificationId(verificationId, smsCode).then(resp => {
        console.log("signInAndRetrieveDataWithCredential ", resp)
        resolve(resp)
      }, error => {
        console.log("signInAndRetrieveDataWithCredential error ", error)
        reject(error)
      })
    })
  }
  phoneAuth(phone, recaptchaVerifier) {
    this.loginMethod = 'phone';
    this.phoneNumber = phone;
    console.log(this.phoneNumber)
    return new Promise((resolve, reject) => {
      this.afAuth.signInWithPhoneNumber("+" + phone, recaptchaVerifier)
        .then((result) => {
          resolve(result.verificationId)
          console.log(result)
        }).catch((error) => {
          console.log(error)
          if (error.code == 'auth/invalid-phone-number')
            reject('Invalid phone number!')
        })
    })
  }

  verifyPhoneAuth(verificationId, code) {
    return new Promise((resolve, reject) => {
      const credential = firebase.auth.PhoneAuthProvider.credential(verificationId, code);
      this.afAuth.signInWithCredential(credential).then(resp => {
        console.log("signInAndRetrieveDataWithCredential ", resp)
        resolve(resp)
      }, error => {
        console.log("signInAndRetrieveDataWithCredential error ", error)
        reject(error)
      })
    })
  }







}
